<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("room.matched")
      }}</strong>
      <router-link v-if="selectedRows.length != 0" :to="`/messenger`">
        <a-button type="primary" icon="form" style="float:right;"
          >Gửi tin nhắn
        </a-button>
      </router-link>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div v-if="loading1" class="loader"></div>
          <div v-else class="card-body">
            <a-table
              :row-selection="rowSelection"
              :columns="columns"
              :dataSource="data"
              :loading="loading"
              @change="handleTableChange"
            >
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column
                }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="c => (searchInput = c)"
                  :placeholder="
                    `Name ${column.dataIndex} or UID ${column.dataIndex}`
                  "
                  :value="selectedKeys[0]"
                  @change="
                    e => setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  >Search</a-button
                >
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                  >Reset</a-button
                >
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
              <template slot="stt" slot-scope="id, record, index">
                {{ index + 1 }}
              </template>
              <template slot="user1" slot-scope="user1, record">
                <router-link :to="`/matched/${record.id}`">
                  <span :class="`name`">
                    {{ user1.fullname || user1.id || "" }}
                  </span></router-link
                >
              </template>
              <template slot="user2" slot-scope="user2, record">
                <router-link :to="`/matched/${record.id}`">
                  <span :class="`name`">
                    {{ user2.fullname || user2.id || "" }}
                  </span></router-link
                >
              </template>
              <template slot="created" slot-scope="created">
                {{ created && created != null ? formatDate(created) : 0 }}
              </template>
              <template slot="time" slot-scope="time">
                {{ get_time(time) }}
              </template>
              <template slot="status" slot-scope="status">
                <span :class="`status_${status}`">{{
                  $t("room.status_" + status)
                }}</span>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    const columns = [
      {
        title: "#",
        width: "50px",
        dataIndex: "id",
        scopedSlots: { customRender: "stt" }
      },
      {
        title: "User 1",
        dataIndex: "user1",
        width: "25%",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "user1"
        },
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            }, 0);
          }
        }
      },
      {
        title: "User 2",
        dataIndex: "user2",
        width: "25%",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "user2"
        },
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            }, 0);
          }
        }
      },
      {
        title: "Created",
        dataIndex: "created",
        width: "15%",
        scopedSlots: { customRender: "created" }
      },
      {
        title: "Time",
        dataIndex: "time",
        width: "10%",
        scopedSlots: { customRender: "time" }
      },
      {
        title: "Status",
        width: "15%",
        dataIndex: "status",
        filters: [
          { text: "Success", value: "1" },
          { text: "Failure", value: "0" }
        ],
        scopedSlots: { customRender: "status" }
      }
    ];
    return {
      selectedRowKeys: [],
      columns,
      data: [],
      loading1: false,
      loading: false,
      selectedRows: [],
      params: null,
      messenger: [],
      search_name: ""
    };
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows;
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
          this.$store.messenger = selectedRows;
          console.log("store", this.$store.messenger);
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.name === "Disabled User", // Column configuration not to be checked
            name: record.name
          }
        })
      };
    }
  },
  methods: {
    formatDate(e) {
      if (e && e !== null) {
        var date = e * 1000;
        let dd = new Date(date).getDate();
        let mm = new Date(date).getMonth() + 1;
        let yyyy = new Date(date).getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        return dd + "/" + mm + "/" + yyyy;
      } else return 0;
    },
    sendMessenger() {
      if (this.selectedRows.length != 0) {
        console.log("Ok");
        // window.location.href = "/messenger";
      } else alert("Chưa chọn đối tượng để gửi tin!");
    },
    async loadData() {
      this.loading1 = true;
      this.api("admin/room?action=detail&id=" + this.$route.params.id).then(
        res => {
          this.data = res.forEach((e, index) => {
            e.key = index;
          });

          this.data = res.map(a => {
            // console.log('dulieu',a);
            if (a.playersId && a.players) {
              a.user1 = a.players[a.playersId[0]];
              a.user2 = a.players[a.playersId[1]];
              a.time = a.ended - a.created || 0;
              a.status = a.state && a.state == "success" ? 1 : 0;
            }
            return a;
          });
          this.sortTime(this.data);
          this.loading1 = false;
          console.log("du lieu load", this.data);
        }
      );
    },
    get_time(e) {
      if (e == 0) return 0;
      let time_h = parseInt(e / 60);
      let time_s = e - time_h * 60;
      return time_h + `p ` + time_s + `s`;
    },
    async handleSearch(selectedKeys, confirm) {
      console.log("data", selectedKeys, selectedKeys.length);
      // if(selectedKeys)
      this.loading = true;
      this.api("admin/room?action=detail&id=" + this.$route.params.id).then(
        async res => {
          this.data = await res.forEach((e, index) => {
            e.key = index;
          });
          // this.data=res
          this.data = await res.map(a => {
            // console.log('dulieu',a);
            if (a.playersId && a.players) {
              a.user1 = a.players[a.playersId[0]];
              a.user2 = a.players[a.playersId[1]];
              a.time = a.ended - a.created || 0;
              a.status = a.state && a.state == "success" ? 1 : 0;
            }
            return a;
          });

          if (selectedKeys && selectedKeys.length > 0) {
            this.search_name = selectedKeys;
            await this.search(selectedKeys);
          }
          if (this.params && this.params.status && this.params.status.length) {
            this.data = this.data.filter(
              rel =>
                rel.status &&
                this.params.status.indexOf(
                  rel.status ? rel.status.toString() : "0"
                ) != -1
            );
          }
          // this.data = await data2;
          this.sortTime(this.data);
          this.loading = false;
        }
      );
    },
    async search(e) {
              await this.sortTime(this.data)
      this.data = await this.data.filter(rel => {
        if (
          (rel.playersId && rel.playersId.indexOf(e[0].trim()) != -1) ||
          (rel.playersId &&
            rel.players &&
            rel.players[rel.playersId[1]].fullname &&
            this.xoa_dau(
              rel.players[rel.playersId[0]].fullname.toUpperCase()
            ).search(this.xoa_dau(e[0].trim().toUpperCase())) != -1) ||
          (rel.playersId &&
            rel.players &&
            rel.players[rel.playersId[1]].fullname &&
            this.xoa_dau(
              rel.players[rel.playersId[1]].fullname.toUpperCase()
            ).search(this.xoa_dau(e[0].trim().toUpperCase())) != -1)
        )
          return rel;
      });
    },
    xoa_dau(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      return str;
    },
    sortTime(a) {
      this.data = a.sort(function(a, b) {
        return new Date(b.created).getTime() - new Date(a.created).getTime();
      });
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
      this.search_name = "";
      // this.handleSearch()
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters
      });
    },
    fetch(params = {}) {
      this.params = params;
      // console.log("params:", params);
      this.loading = true;
      this.api("admin/room?action=detail&id=" + this.$route.params.id).then(
        res => {
          this.data = res.forEach((e, index) => {
            e.key = index;
          });

          this.data = res.map(a => {
            // console.log('dulieu',a);
            if (a.playersId && a.players) {
              a.user1 = a.players[a.playersId[0]];
              a.user2 = a.players[a.playersId[1]];
              a.time = a.ended - a.created || 0;
              a.status = a.state && a.state.trim() == "success" ? 1 : 0;
            }
            return a;
          });
          // console.log("length",params);

          if (params && params.status && params.status.length > 0) {
            this.data = this.data.filter(
              rel =>
                params.status.indexOf(
                  rel.status ? rel.status.toString() : "0"
                ) != -1
            );
          }
          if (
            this.search_name &&
            this.search_name.toString().trim().length > 0
          ) {
            this.search(this.search_name);
          }
          this.sortTime(this.data);
          this.loading = false;
          // console.log("du lieu", this.data);
        }
      );
    }
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper]
};
</script>
<style scoped>
/* loading */
.loader {
  border: 2px solid #f3f3f3;
  border-radius: 50%;
  border-top: 2px solid #ff8943;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
  margin: 20px auto;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.top_matched {
  margin-bottom: 20px;
}
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
.status_0 {
  color: grey;
}
.status_1 {
  color: green;
}
.name {
  color: #ff5254;
}
</style>
